export default "__VITE_ASSET__CeMhnjmU__"